var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stk-py-6"},[_c('RecommendationsInbox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }